import React, { useEffect, useRef } from "react";
import "./ListItemsMenu.css";

const ListMenuComponent = ({ selectedDiv, handleChange, setIsMenuOpen }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsMenuOpen]);

  return (
    <div key="items" className="MenuListItems" ref={menuRef}>
      <label htmlFor="items">Items (newline-separated): </label>
      <textarea
        id="items"
        name="items"
        value={selectedDiv ? selectedDiv.items : ""}
        onChange={handleChange}
        placeholder="Enter items separated by newline ('/n')"
        rows={10}
        cols={30}
      />

      <button onClick={() => setIsMenuOpen(false)} className="save-button">
        Done
      </button>
    </div>
  );
};

export default ListMenuComponent;
